import React, { useContext, useEffect, useState, useTransition } from "react";
import "./Login.scss";
import "./LoginMobile.scss";
import { useForm } from "react-hook-form";
import Input from "@components/input/Input";
import Captcha from "@components/captcha/Captcha";
import { useTurnstile } from "react-turnstile";
import MessageServices from "@services/MessageServices";
import Button from "@components/button/Button";
import IconKtech from "@icons/IconKtech";
import UtilServices from "@services/UtilServices";
import EndPointServices from "@services/ApiServices";
import { useNavigate } from "react-router-dom";
import GlobalContext from "@context/GlobalContext";
import { ToastContainer } from "react-toastify";
import Loading from "@components/loading/Loading";
import Rodape from "@pages/rodape/Rodape";
import Modal from "@components/modal/Modal";
import useAutenticar from "@hooks/useAutenticar";
import { AppsLogin } from "@pages/appslogin/Appslogin";

const Login = () => {
  const [isPending, startTransition] = useTransition();
  const { handleAutenticar } = useAutenticar();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      login:
        process.env.NODE_ENV === "development" ? "kaiquealbano@gmail.com" : "",
      senha: process.env.NODE_ENV === "development" ? "admin@941360" : "",
    },
  });

  //Variaveis Padrões
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();

  //Captcha
  const [countTentativa, setCountTentativa] = useState(0);
  const turnstile = useTurnstile();
  const [tokenVerificado, setTokenVerificado] = useState(false);

  //MudarSenha
  const [showModal, setShowModal] = useState(false);
  const [senhaAntiga, setSenhaAntiga] = useState("");
  const [idLogin, setIdLogin] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!UtilServices.getStorage("idsistema_redirect")) {
      UtilServices.setStorage("idsistema_redirect", "1");
    }
    handleLoginRedirect();
  }, []);

  async function handleLoginRedirect() {
    if (
      handleAutenticar() &&
      UtilServices.getStorage("idsistema_redirect") === "1"
    ) {
      try {
        await EndPointServices.Autentica_VerificaSessaoSemError();
        navigate("/RPA/EFDContribuicoes");
      } catch {}
    }
  }

  function handleLogin(data) {
    data.idsistema = UtilServices.getStorage("idsistema_redirect");

    startTransition(async () => {
      setSenhaAntiga(data.senha);
      /*--Autentica Login--*/
      var retornoapi = await EndPointServices.Autentica_Login(data);
      if (retornoapi?.Success) {
        //VERIFICAR SE A SENHA É mudar321
        if (data.senha === "mudar321") {
          setIdLogin({
            id_usuario: retornoapi?.BaseReturn?.LstClasse[0].id_usuario,
            id_usuario_guid:
              retornoapi?.BaseReturn?.LstClasse[0].id_usuario_guid,
            login: data.login,
          });
          setShowModal(true);
          return;
        }

        //recupera o token.
        UtilServices.managerToken(retornoapi?.BaseReturn?.Classe);

        //Seta Dados do Usuario
        UtilServices.setStorage(
          "dadosusuario",
          retornoapi?.BaseReturn?.LstClasse[0],
        );

        dispatch({
          type: "SET_USUARIO",
          payload: retornoapi?.BaseReturn?.LstClasse[0],
        });

        reset(); //Reseta todos useForm

        if (UtilServices.getStorage("idsistema_redirect") === "1") {
          navigate("/RPA/EFDContribuicoes");
        }
        if (UtilServices.getStorage("idsistema_redirect") === "2") {
          navigate("/ConsultaIbscbs");
        }
      }
    });
  }
  async function handleVerify(tokenCaptcha) {
    let data = {
      Token: tokenCaptcha,
    };
    try {
      let resp = await EndPointServices.Externo_VerificaTokenCaptcha(data);
      let respJson = typeof resp === "string" ? JSON.parse(resp) : resp;

      if (respJson?.success) {
        setTokenVerificado(true);
      } else {
        handleOnErrorCaptcha();
      }
    } catch (ex) {
      handleOnErrorCaptcha();
    }
  }
  function handleOnErrorCaptcha() {
    if (countTentativa <= 2) {
      //faz 3 tentativas no captcha.
      setTimeout(() => {
        turnstile.reset();
        setCountTentativa(countTentativa + 1);
      }, 2000);
    } else {
      MessageServices.ShowError("Ocorreu um erro na validação do CAPTCHA.");
    }
  }
  async function handleMudarSenha(e) {
    startTransition(async () => {
      if (senhaAntiga === e?.senhamudar) {
        MessageServices.ShowWarning(
          "A nova senha não pode ser igual à anterior.",
        );
        return;
      }

      let data = {
        senha: e?.senhamudar,
        id_usuario: idLogin?.id_usuario,
        id_usuario_guid: idLogin?.id_usuario_guid,
        login: idLogin?.login,
      };

      var retornoapi = await EndPointServices.Autentica_AtualizaSenha(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess("Sua senha foi alterada com sucesso.");
        setTimeout(() => {
          setShowModal(false);
          handleLogin(data);
        }, 2000);
      }
    });
  }

  return (
    <>
      <div className="login row">
        <div className="usuario-senha mt-4 mt-sm-0 col-12 col-md-3">
          <div className="usuario-senha-form">
            <div className="icone-mobile" style={{ display: "none" }}>
              <IconKtech
                width={100}
                onClick={() => {
                  navigate("/");
                }}
              />
            </div>
            <form onSubmit={handleSubmit(handleLogin)}>
              <div>
                <div className="bem-vindo">
                  <p>Bem vindo.</p>
                  <p className="texto-acesse">Acesse com CPF ou Email.</p>
                </div>
                <div className="usuario">
                  <Input
                    placeholder="CPF/CNPJ ou Email"
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    name="login"
                    mask="CPF"
                    registerProps={{
                      required: "O Login é obrigatório",
                    }}
                    type="cpfemail"
                  />
                </div>
                <div className="senha">
                  <Input
                    placeholder="Senha"
                    type="password"
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    registerProps={{
                      required: "Senha é obrigatório",
                      validate: {
                        minLength: (value) =>
                          value.length >= 8 ||
                          "a senha deve ter no mínimo 8 caracteres",
                      },
                    }}
                    name="senha"
                  />
                </div>
                <Captcha
                  onVerify={handleVerify}
                  sitekey={
                    process.env.NODE_ENV === "development"
                      ? "1x00000000000000000000AA"
                      : "0x4AAAAAABv2QRp8OOEgERQZ"
                  }
                />
                <div className="button-entrar">
                  <Button nome="ENTRAR" disabled={!tokenVerificado} />
                </div>
                <div className="cadastrar">
                  {/* <a
                    onClick={() => {
                      MessageServices.ShowWarning("#Em Desevolvimento!");
                    }}
                  >
                    Cadastrar-se
                  </a> */}
                </div>
              </div>
            </form>
            <div className="mt-3">
              <p className="text-xs text-white mb-3 text-center">
                Selecione o sistema
              </p>
              <AppsLogin />
            </div>
          </div>
        </div>
        <div className="icone col-12 col-md-6">
          <IconKtech
            width={180}
            className="ktecnoicon"
            onClick={() => {
              navigate("/");
            }}
          />
          <ToastContainer />
          <Loading color="#c1abff" show={isPending} />
        </div>
        <Modal
          botaoExcluir={false}
          showModal={showModal}
          setShowModal={setShowModal}
          title="Alerta"
          width="350px"
        >
          <form onSubmit={handleSubmit(handleMudarSenha)}>
            <div className="alterar-senha">
              <p>
                Sua senha precisa ser redefinida para que a autenticação seja
                concluída com sucesso.
              </p>
              <div className="input-loginsenha">
                <Input
                  placeholder="Nova Senha"
                  type="password"
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  registerProps={{
                    required: "Senha é obrigatório",
                    validate: {
                      minLength: (value) =>
                        value.length >= 8 ||
                        "a senha deve ter no mínimo 8 caracteres",
                    },
                  }}
                  theme="4"
                  name="senhamudar"
                />
                <Input
                  placeholder="Confirmar Senha"
                  type="password"
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  registerProps={{
                    required: "Confirme a senha é obrigatório",
                    validate: {
                      isValid: (value) =>
                        value === watch("senhamudar") ||
                        "A senha que você digitou não corresponde",
                    },
                  }}
                  theme="4"
                  name="copiarsenhamudar"
                />
                <div className="botao-alterar">
                  <Button nome="Alterar" />
                </div>
              </div>
            </div>
          </form>
        </Modal>
      </div>
      <Rodape
        backgroundcolor="var(--color-rodape)"
        iconktech="black"
        color="var(--color-03)"
        colorlinha="var(--color-03)"
      />
    </>
  );
};

export default Login;
